// extracted by mini-css-extract-plugin
module.exports = {"whatsapp":"WhatsApp_whatsapp__12rNb","icon":"WhatsApp_icon__2YG53"};